module.exports = __webpack_public_path__ + "img/contrast-01.4ad143b2.svg";